import { ingestAPIObject } from "../utils/api";
export class CreateRanchSeasonDTO {
}
export class RanchSeasonDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
}
